import React, {
  useEffect,
  useLayoutEffect,
  useState,
  useRef,
} from "react";

import AlertsFilter from "../components/alerts_filter/alerts-filter";
import moment from "moment";
import { getApiUrl } from "../utils/config-utility";
import axios from 'axios';

const ScreenShotResidential = () => {
  const [leakAlerts, setLeakAlerts] = useState([]);
  const [deviceAlerts, setDeviceAlerts] = useState([]);
  const [customerChartData, setCustomerChartData] = useState({});
  const filterRef = useRef(null);

  const displayAlertTime = ((date) => {
    return moment(date).format("DD MMM yyyy");
  });

  const displaySeverity = ((severity) => {
    return (
      <span className={`alert-severity alert-severity--${severity}`}>
        {severity.charAt(0).toUpperCase() + severity.slice(1)}
      </span>
    );
  });


const roundTo2Decimal = (value) => Number(value.toFixed(2));

const getChartData = (arr_usage) => {
  const dataPoints = arr_usage.length // Number of bars in the mini chart
  const data = []

  for (let i = 0; i < dataPoints; i++) {
    const value = arr_usage[i] || 0 // Default to 0 if no data
    data.push(value['total_consumption']*20)
  }
  return data
}

const CustomerTypeBarChart = (arr_usage) => {
  const chartData = getChartData(arr_usage)
  const maxHeight = 24 // Maximum height in pixels

  return (
    <div className="w-full">
      <div className="d-flex items-end gap-05 h-6">
        {chartData.map((dataPoint, index) => (
          <div
            key={index}
            className="bg-green-500 w-2 rounded-sm"
            style={{
              height: `${dataPoint * maxHeight}px`,
            }}
          />
        ))}
      </div>
    </div>
  )
}

  useEffect(() => { 
    const ignore = false;
    if (!ignore)  loadData()
    return () => { ignore = true; }
  },[]);

  const loadData = async () => {
  const tenant_id = 6;
  const { data: leakData } = await axios.get(`${getApiUrl()}/leak-alerts-screenshot?tenant_id=${tenant_id}`);
  const { data: deviceData } = await axios.get(`${getApiUrl()}/device-alerts-screenshot?tenant_id=${tenant_id}`);

  setLeakAlerts(leakData['data']);
  setDeviceAlerts(deviceData['data']);

  // Fetch chart values for each unique customer
  const chartDataMap = {};
  for (const alert of leakData['data']) {
    if (!chartDataMap[alert.customer_id]) {
      const { data: usageData } = await axios.get(`${getApiUrl()}/get-usage-data-for-residential-alert?customer_id=${alert.customer_id}`);
      chartDataMap[alert.customer_id] = usageData;
    }
  }
  setCustomerChartData(chartDataMap);
};


  useLayoutEffect(() => {
    import("./style-screenshot-alert.scss");
  }, []);

  return (
    <div className="wrapper">
     <div className="the-content">
      <div className="container-fluid content">
        <div className="action-buttons block-center-between">
          <div className="block-center" style={{opacity: "0"}}>
            <AlertsFilter
              ref={filterRef}
              onFiltersApply={loadData}
            />
          </div>
        </div>
        {leakAlerts.length > 0 && (
          <>
            <div>
              <h2 className="title mb-0">Leak alerts</h2>
            </div>
            <div className="mt-5">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Customer</th>
                      <th scope="col">Start date</th>
                      <th scope="col">End date</th>
                      <th scope="col">Leak intensity</th>
                      <th scope="col">Leak rate L/hr</th>
                      <th scope="col">Leak rate L/d</th>
                      <th scope="col">Leak Duration</th>
                      <th scope="col">Leak value $/year</th>
                      <th scope="col">Leak profile</th>
                    </tr>
                  </thead>
                  <tbody>
                    {leakAlerts.map((alert, index) => (
                      <tr key={index}>
                        <td scope="col" style={{width: '22%'}}>
                          {alert.concat_customer_name}
                        </td>
                        <td scope="col">{displayAlertTime(alert.start_date)}</td>
                        <td scope="col">{displayAlertTime(alert.end_date)}</td>
                        <td scope="col">{displaySeverity(alert.severity)}</td>
                        <td scope="col">{roundTo2Decimal(alert.avg_allDayUsageLPH)}</td>
                        <td scope="col">{roundTo2Decimal(alert.avg_allDayUsageLPD)}</td>
                        <td scope="col">{alert.count}</td>
                        <td scope="col">{roundTo2Decimal(alert.leak_year_value)}</td>
                        <td scope="col">
                          {customerChartData[alert.customer_id] !== undefined &&
                            CustomerTypeBarChart(customerChartData[alert.customer_id])}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
       
        {/* List Alert */}

        {/* Start Device and Pressure Alert */}
        {deviceAlerts.length > 0 && (
          <>
            <div>
              <h2 className="title mb-0">Device alerts</h2>
            </div>
            <div className="mt-5">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Customer</th>
                      <th scope="col">Date</th>
                      <th scope="col">Alarm description</th>
                      <th scope="col">Code</th>
                      <th scope="col">Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deviceAlerts.map((item, index) => (
                      <tr key={index}>
                        <td scope="col" style={{width: '22%'}}>{item.concat_customer_name}</td>
                        <td scope="col">{displayAlertTime(item.log_date)}</td>
                        <td scope="col">{item.alert_name}</td>
                        <td scope="col">{item.code}</td>
                        <td scope="col">{item.description}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
        {/* End Device and Pressure Alert */}
      </div>
    </div>
   </div>
  );
}

export default ScreenShotResidential



